import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div id={{this.elementId}} {{did-insert this.onDidInsert}} {{will-destroy this.onWillDestroy}}>\n  {{yield (hash inViewport=this.inViewport)}}\n</div>", {
  moduleName: "@dashboard/shared-ui/components/scroll-monitor/section.hbs"
});